import Vue from 'vue';
import VueRouter from 'vue-router';
import DashHome from '@/components/router-views/DashHome';
import AdminHome from '@/components/router-views/AdminHome';
import LearnerHome from '@/components/router-views/LearnerHome';
import InstructorHome from '@/components/router-views/InstructorHome';
import SimpleDash from '@/components/SimpleDash';
import Groups from '@/components/modal-views/groups/Groups';
import GoogleAssignmentPicker from '@/components/modal-views/GoogleClassroomAssignmentPicker';
import GoogleClassPicker from '@/components/modal-views/GoogleClassPicker';
import GoogleClassroomStudentSignIn from '@/components/modal-views/GoogleClassroomStudentSignIn';

// TODO implement: leaving here for now, will add back later.
// import {
//   beforeEachRouteNavigationGuard,
// } from '@/router/util/helpers';

Vue.use(VueRouter);

const routes = [
  {
    path: '/dash',
    redirect: '/dash/home/',
  },
  {
    path: '/dash/home/',
    name: 'dashboard',
    component: DashHome,
  },
  {
    path: '/dash/admin/:activeView/:secondaryView',
    name: 'admin',
    component: AdminHome,
  },
  {
    path: '/dash/learner/:activeView/:secondaryView',
    name: 'learner',
    component: LearnerHome,
  },
  {
    path: '/dash/instructor/:activeView/:secondaryView',
    name: 'instructor',
    component: InstructorHome,
  },
  {
    path: '/dash/classpicker/:bulb_id/:teacher_id',
    name: 'classpicker',
    component: SimpleDash,
  },
  {
    path: '/dash/bluescreen',
    name: 'bluescreen',
    component: SimpleDash,
  },
  {
    path: '/dash/lti',
    name: 'lti',
    component: SimpleDash,
  },
  {
    path: '/dash/oauth/:type',
    name: 'oauth',
    component: SimpleDash,
  },
  {
    path: '/dash/groups/:sectionId',
    name: 'groups',
    component: Groups,
    props: (route) => ({
      sectionId: route.params.sectionId,
      initialTab: route.query.initialTab,
      routerView: true,
    }),
  },
  {
    path: '/dash/googleClassPicker',
    name: 'googleClassPicker',
    component: GoogleClassPicker,
  },
  {
    path: '/dash/googleAssignmentPicker',
    name: 'googleAssignmentPicker',
    component: GoogleAssignmentPicker,
  },
  {
    path: '/dash/googleStudentSignIn',
    name: 'googleStudentSignIn',
    component: GoogleClassroomStudentSignIn,
  },
  {
    path: '/dash/lti/custom',
    name: 'customLtiDash',
  },
];

const router =  new VueRouter({
  mode: 'history',
  routes,
});

export default router;